<template>
  <div class="lefted">
    <h1 class="title is-5"></h1>
    <div v-if="eumAuthStatus != 'failed'">
      <div id="logon-loading-message" class="signin signin-h2">
        <!-- <div class="finding">Finding user</div>
        <div class="authenticating">Logging in</div>
        <div class="authorizing">Authorizing</div> -->
      </div>
      <button v-show="!$loginInProgress" id="internal-login-btn" 
              class="button signin-btn is-dark is-large" :disabled="$loginInProgress" @click.prevent="doLogin">
        Sign In <img class="ml-4" src="/img/mssymbol.svg" alt="MS logo" />
      </button>
      <!-- <button class="button is-dark is-large" style="margin-left: 15px" @click.prevent="doLogin">
        Client Sign In <img class="ml-4" src="/img/mssymbol.svg" alt="MS logo" />
      </button> -->
      <div v-if="error && eumAuthStatus != 'failed'" class="notification is-warning mt-4">
        {{ error }}
      </div>
    </div>
    <div v-else>
      <div v-if="eumAuthStatus === 'failed'">
        <br>
        <h3 class="signin" style="margin-top:60px;">EUM user permissions not found</h3>
        <div v-if="error" class="notification is-warning mt-4">
          {{ error }}
        </div>
      </div>
      <div style="margin-top:.4em;">
        <a v-show="false" href="#" @click="requestAccess">Request Access</a>
      </div>
    </div>
  </div>
</template>
<script>


import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  data: function () {
    return {
      eumAuthStatus: 'none',
      error: ''
      
    }
  },
   computed: {

     $eumAuth: function(){
       return this.$root.$eumAuth;
     },
     $loginInProgress: function(){
       return this.$store.getters['authModule/loginInProgress'];
     },
     $authStatus: {
        get() {
          return this.$store.getters['authModule/authStatus'];          
        },
        set(val) {
          this.$store.dispatch('authModule/SetAuthStatus',val);

        }


     }
    
  },
  mounted: function() {
     this.$on('eum-auth-failed', () => {
        this.$parent.$emit('eum-auth-failed');
      })
  },
  methods: {
    ...mapActions('authModule', ['SetMsalUser','SetLoggedInUser', 'LogoutUser']),
    ...mapGetters('authModule', ["appuser","idtoken","accesstoken","authStatus","userIsAuthenticated","userIsAuthorized"] ),
    ...mapActions('getModule', ['getDataWithQuery', 'GetItems', 'GetItemsWithFlag','GetAllItemsUnbundled','SetProgramList']),
   async requestAccess(){


    },
    
    async doLogin() {

      this.$store.dispatch("authModule/SetLoginInProgress",true);

       let btnwidth=$('#internal-login-btn').css('width');
       let btnhgth=$('#internal-login-btn').css('height');
      
       let btn =  document.getElementById("internal-login-btn");
       //$('#internal-login-btn').text("Processing...");
       $('#internal-login-btn').css('min-width',btnwidth);
       $('#internal-login-btn').css('min-height',btnhgth);
     
       
       let tkn = null;

      let self = this
      let uitoken;
     
      try {
        console.log(`Login.vue doLogin() starting...`);
        this.eumAuthStatus = 'started';
        this.$authStatus = 1;
    
       let usr = await this.$eumAuth.user();
       let apitoken = this.$store.getters['authModule/api_idtoken'];
       if ( typeof(apitoken) != "undefined" && apitoken.length != 0)
        {
          this.$store.dispatch('authModule/SetAuthorized',true);
          this.$store.dispatch('authModule/SetAuthStatus',3);

        }
         else 
         { 
          this.eumAuthStatus = `failed`;
            this.$emit('eum-auth-failed');
            this.error = `We could not find the user permissions required for you to use the EUM application.`;
       

        }
      } catch (err) {
        this.eumAuthStatus = 'failed';
        this.error = err.toString()
         this.$emit('eum-auth-failed');
         $("#internal-login-btn").text("Internal User Sign In");

      }
    },
  },
 
}
</script>

<style scoped>
.lefted {
  display: inline-block;
  text-align: left;
  width: 50%;
  margin-top: 50px;
}
</style>